import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	dialogContent: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		textAlign: "center",
		overflow: "hidden",
		padding: theme.spacing(0),
		"&:first-child": {
			paddingTop: 0
		}
	},
	dialogPaper: {
		borderRadius: theme.spacing(2),
		maxHeight: "auto",
		padding: "24px 32px"
	},
	iconSquare: {
		width: 64,
		height: 64,
		borderRadius: theme.spacing(1.5),
		background: `linear-gradient(135deg, ${colors.purple[500]} 0%, ${colors.purple[400]} 100%)`,
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	icon: {
		"& path": {
			fill: colors.gray[0]
		}
	},
	title: {
		color: colors.gray[800],
		fontWeight: 600,
		fontSize: 20
	},
	description: {
		color: colors.gray[500],
		maxWidth: 420
	},
	benefitsCard: {
		backgroundColor: colors.purple[50],
		border: `1px solid ${colors.purple[100]}`,
		borderRadius: theme.spacing(2),
		padding: theme.spacing(2),
		width: "100%"
	},
	benefitItemIcon: {
		color: colors.gray[600],
		flexShrink: 0
	},
	benefitItemText: {
		fontSize: 13,
		fontWeight: 600,
		color: colors.gray[600]
	},
	footer: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		gap: theme.spacing(1),
		width: "100%",
		maxWidth: 420
	},
	primaryButton: {
		borderRadius: theme.spacing(1),
		height: theme.spacing(6),
		fontSize: 14,
		flexGrow: 1,
		padding: theme.spacing(1, 2),
		backgroundColor: colors.purple[500],
		color: colors.gray[0],
		"&:hover": {
			backgroundColor: colors.purple[600]
		}
	},
	secondaryButton: {
		color: colors.gray[500],
		borderRadius: theme.spacing(1),
		height: theme.spacing(6),
		fontSize: 14
	}
}))

export default useStyles
